import { render, staticRenderFns } from "./Abacus.vue?vue&type=template&id=64ef9b90&scoped=true&"
import script from "./Abacus.vue?vue&type=script&lang=js&"
export * from "./Abacus.vue?vue&type=script&lang=js&"
import style0 from "./Abacus.vue?vue&type=style&index=0&id=64ef9b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef9b90",
  null
  
)

export default component.exports